import { Button, ConfigProvider, Form, Input, message, Modal, Radio } from 'antd'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { addTaxonomy, modifyTaxonomy } from '../../apis/taxonomy'
import styled from 'styled-components'

const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  gap: 8px;
`

const ParentModal = props => {
  const { t: ln_t } = useTranslation()
  const { openModal, setOpenModal, formMode, setFormMode, taxonomyData, setTaxonomyData, handleFetchParams, groupId } = props
  const user = useSelector((state) => state.user)
  const admin = useSelector((state) => state.admin)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  const defPlaceholder = (name, type) => {
    const message = type === 'input' ? ln_t('util.pleaseEnter') : type === 'select' ? ln_t('util.pelaseSelect') : ''
    return `${message} ${ln_t(`dataSource.${name}`)}`
  }
  const defConfig = (name, type, required = true) => ({ name, label: ln_t(`dataSource.${name}`), rules: [{ required, message: defPlaceholder(name, type) }] })

  const handleCancel = () => {
    setOpenModal(false)
    setFormMode('')
    setTaxonomyData({})
    form.resetFields()
  }

  const handleAdd = async reqBody => {
    setLoading(true)
    const result = await addTaxonomy(reqBody)
    if (result?.status === 201) {
      message.success(ln_t('message.success.create'))
      handleFetchParams('add', {})
      handleCancel()
    }
    setLoading(false)
  }

  const handleEdit = async reqBody => {
    setLoading(true)
    const result = await modifyTaxonomy(taxonomyData.id, reqBody)
    if (result?.status === 200) {
      message.success(ln_t('message.success.modify'))
      handleFetchParams('add', {})
      handleCancel()
    }
    setLoading(false)
  }
  const onFinish = async fieldsValue => {
    const { name, status } = fieldsValue
    const parentId = formMode === 'addChildTaxonomy' ? taxonomyData.id : 0
    const reqBody = { name, groupId: admin.active ? groupId : user.nowGroup, status, parentId }
    formMode === 'edit' ? handleEdit(reqBody) : handleAdd(reqBody)
  }

  useEffect(() => { if (formMode === 'edit') form.setFieldsValue(taxonomyData) }, [openModal])

  const formTitle = {
    add: `${ln_t('util.add')} ${ln_t('taxonomy.taxonomy')}`,
    edit: `${ln_t('util.edit')} ${ln_t('taxonomy.taxonomy')}`,
    addChildTaxonomy: `${ln_t('util.add')} ${ln_t('taxonomy.taxonomy')} ${ln_t('taxonomy.under')} ${taxonomyData?.name}`
  }

  return (
    <Modal title={formTitle[formMode]} open={openModal} onCancel={handleCancel} footer={null} width='500px'>
      <ConfigProvider theme={{ token: { colorPrimary: 'rgb(71, 182, 175)', colorPrimaryHover: 'rgba(71, 182, 175,.8)' } }}>
        <Form form={form} layout="vertical" onFinish={onFinish} requiredMark={false} style={{ margin: '24px 0px 16px' }}>
          <Form.Item {...defConfig('name', 'input')}>
            <Input placeholder={defPlaceholder('name', 'input')} />
          </Form.Item>
          <Form.Item {...defConfig('status', 'select')} initialValue={1}>
            <Radio.Group
              options={[{ value: 1, label: ln_t('util.enable') }, { value: 0, label: ln_t('util.disable') }]}
              optionType="button"
              buttonStyle="solid"
            />
          </Form.Item>
          <FormButton>
            <Button type="default" onClick={() => handleCancel()}>{ln_t('util.cancel')}</Button>
            <Button type="primary" htmlType="submit" loading={loading}>{ln_t('util.confirm')}</Button>
          </FormButton>
        </Form>
      </ConfigProvider>
    </Modal>
  )
}

export default ParentModal
